import {DataStatus} from 'platform/components';
import {Show, VStack} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetServiceOrderIntegrationsQuery} from '@dms/api/workshop';

import {TestIdProps} from 'shared/web';

import {useIntegrationsEnabled} from '../../../../../pages/ServiceCaseDetail/hooks/useIntegrationsEnabled';
import {OrderClaraInformation} from './OrderClaraInformation';
import {OrderEvaClaimInformation} from './OrderEvaClaimInformation';
import {OrderXentryInformation} from './OrderXentryInformation';

interface OrderDetailProps extends TestIdProps {
  orderId: string;
  serviceCaseId: string;
}

export function OrderDetailAdditionalInformation(props: OrderDetailProps) {
  const {
    data: serviceOrderIntegrations,
    isLoading: isServiceOrderIntegrationsLoading,
    isError: isServiceOrderIntegrationsError,
  } = useGetServiceOrderIntegrationsQuery(
    {
      serviceCaseId: props.serviceCaseId,
      serviceOrderId: props.orderId,
    },
    {skip: isNilOrEmpty(props.serviceCaseId) || isNilOrEmpty(props.orderId)}
  );

  const {
    isClaraIntegrationEnabled,
    isDaimlerXentryIntegrationEnabled,
    isEvaClaimIntegrationEnabled,
    isLoading: isIntegrationsLoading,
    isError: isIntegrationsError,
  } = useIntegrationsEnabled({
    serviceCaseId: props.serviceCaseId,
    orderIntegrations: serviceOrderIntegrations ?? {orderIntegration: []},
  });

  const isLoading = isServiceOrderIntegrationsLoading || isIntegrationsLoading;
  const isError = isServiceOrderIntegrationsError || isIntegrationsError;

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <VStack spacing={1}>
        <Show when={isClaraIntegrationEnabled}>
          <OrderClaraInformation orderId={props.orderId} serviceCaseId={props.serviceCaseId} />
        </Show>
        <Show when={isDaimlerXentryIntegrationEnabled}>
          <OrderXentryInformation orderId={props.orderId} serviceCaseId={props.serviceCaseId} />
        </Show>
        <Show when={isEvaClaimIntegrationEnabled}>
          <OrderEvaClaimInformation orderId={props.orderId} serviceCaseId={props.serviceCaseId} />
        </Show>
      </VStack>
    </DataStatus>
  );
}
